import { defineAsyncComponent } from "vue";
const FilePickerVue = defineAsyncComponent(() => import("./FilePicker-CsU6FfAP.mjs"));
export {
  FilePickerVue
};
//# sourceMappingURL=index-BC-7VPxC.mjs.map
